import { render } from "./AanmeldenView.vue?vue&type=template&id=5c89cde4&scoped=true"
import script from "./AanmeldenView.vue?vue&type=script&lang=js"
export * from "./AanmeldenView.vue?vue&type=script&lang=js"

import "./AanmeldenView.vue?vue&type=style&index=0&id=5c89cde4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c89cde4"]])

export default __exports__